import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

const SessionTimer = () => {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("jwt");
    if (!token) return;

    const { exp } = jwtDecode(token);
    const interval = setInterval(() => {
      const secondsLeft = Math.floor(exp - Date.now() / 1000);
      setTimeLeft(secondsLeft > 0 ? secondsLeft : 0);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${hrs}h ${mins}m ${secs}s`;
  };

  if (timeLeft === null) return null;

  return (
    <div style={{
      position: "fixed",

      right: "10px",
      backgroundColor: timeLeft < 60 ? "#dc3545" : "#28a745",
      color: "white",
      padding: "8px 12px",
      borderRadius: "5px",
      fontWeight: "bold",
      zIndex: 1000,
      top: "10px"

    }}>
      Sesión expira en: {formatTime(timeLeft)}
    </div>
  );
};

export default SessionTimer;
